import { t } from "../locale";

/**
 * @param {Fencealarm} fa
 * @returns {string}
 */
function checkLowBatteryAlarm(fa) {
	if (!fa.LowBatteryAlarm.Triggered) return "";
	return t.fencealarm.card.lowBatteryWarning;
}

/**
 * @param {Fencealarm} fa
 * @returns {string}
 */
function checkOfflineAlarm(fa) {
	if (!fa.OfflineAlarm.Triggered) return "";
	return t.device.card.connectionWarning;
}

/**
 * @param {Fencealarm} fa
 * @returns {string}
 */
function checkVoltageAlarm(fa) {
	if (!fa.VoltageAlarm.Enabled) return "";
	if (!fa.VoltageAlarm.Triggered) return "";
	return t.fencealarm.card.lowVoltageWarning;
}

/**
 * @param {Fencealarm} fa
 * @returns {string[]}
 */
function getFencealarmWarnings(fa) {
	return [
		checkLowBatteryAlarm(fa),
		checkOfflineAlarm(fa),
		checkVoltageAlarm(fa),
	].filter((text) => text !== "");
}

export { getFencealarmWarnings };
